import React from "react";

/**
 * Official Manish Labchem Pvt. Ltd. logo.
 * Uses the brand image from /images/logo.png
 */
const LogoMark = ({ size = 56, className = "", variant = "default" }) => {
  const isDark = variant === "dark";
  return (
    <div
      className={`inline-flex items-center justify-center ${isDark ? "bg-white" : ""} rounded-lg ${className}`}
      style={{ height: size, width: "auto", padding: isDark ? 4 : 0 }}
    >
      <img
        src="/images/logo.png"
        alt="Manish Labchem Pvt. Ltd."
        style={{ height: isDark ? size - 8 : size, width: "auto", objectFit: "contain", display: "block" }}
        loading="eager"
      />
    </div>
  );
};

export default LogoMark;
